import '../../assets/css/popmodel/PermissionModal.css';

function PermissionModal({ permissions = [], onClose }) {
  const groupPermissions = (flatPermissions) => {
    return flatPermissions.reduce((acc, perm) => {
      if (!perm) return acc;
      const [action, module] = perm.split('_');
      if (!action || !module) return acc;

      if (!acc[module]) acc[module] = [];
      if (!acc[module].includes(action)) acc[module].push(action);

      return acc;
    }, {});
  };

  const capitalize = (word) => word.charAt(0).toUpperCase() + word.slice(1);

  const grouped = groupPermissions(permissions);

  return (
    <div
      className="modal-overlay"
      role="dialog"
      aria-modal="true"
      onClick={onClose}
    >
      <div
        className="bottom-slide-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-content border-0 shadow">
          {/* Header */}
          <div className="modal-header   py-2 px-3 d-flex justify-content-between align-items-center">
            <h5 className="modal-title fw-bold">Permissions</h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              aria-label="Close"
              onClick={onClose}
            ></button>
          </div>

          {/* Body */}
          <div className="modal-body bg-white px-4 py-3">
            {Object.keys(grouped).length > 0 ? (
              <div className="table-responsive">
                <table className="table table-bordered table-hover small">
                  <thead className="table-light">
                    <tr>
                      <th>Module</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.entries(grouped).map(([module, actions]) => (
                      <tr key={module} style={{border:'1px solid #102234'}}>
                        <td className="fw-bold">{capitalize(module)}</td>
                        <td>
                          {actions.map((action, i) => (
                            <span key={i} className="badge bg-secondary me-2">
                              {capitalize(action)}
                            </span>
                          ))}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p className="text-center text-muted">No permissions assigned.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PermissionModal;
